var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-medium"},[_c('v-chip',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.formatName())+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }